import React, { useEffect, useState } from "react";
import { Home, Gamepad2, Info, ShieldCheck } from "lucide-react"; 
import { Link, useLocation } from "react-router-dom";

const BottomNav = () => {
  const location = useLocation();
  const [active, setActive] = useState(location.pathname);

  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  const navLinks = [
    { title: "Home", icon: Home, href: "/", ariaLabel: "Go to Home Page" },
    { title: "Games", icon: Gamepad2, href: "/games", ariaLabel: "Browse All Games" },
    { title: "About", icon: Info, href: "/about", ariaLabel: "Read About Us" },
    { title: "Privacy", icon: ShieldCheck, href: "/privacy-policy", ariaLabel: "Read Privacy Policy" },
  ];

  return (
    <nav 
      aria-label="Bottom Navigation"
      className="fixed overflow-hidden bottom-0 left-0 w-full bg-gray-900 border-t border-gray-700 flex justify-around items-center py-2 z-50"
    >
      {navLinks.map((link) => {
        const Icon = link.icon;
        const isActive = active === link.href;

        return (
          <Link
            key={link.title}
            to={link.href}
            title={link.ariaLabel} 
            aria-label={link.ariaLabel}
            aria-current={isActive ? "page" : undefined} 
            className="flex flex-col items-center gap-0.5 text-xs font-medium transition-all duration-200"
          >
            <Icon
              className={`w-6 h-6 transition-all duration-200 ${
                isActive
                  ? "text-blue-400 stroke-[3]"
                  : "text-gray-400 hover:text-white stroke-[2]"
              }`}
              aria-hidden="true" 
            />
            <span
              className={`transition-all duration-200 ${
                isActive
                  ? "text-blue-400 font-extrabold"
                  : "text-gray-400 hover:text-white font-medium"
              }`}
            >
              {link.title}
            </span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNav;